import { render, staticRenderFns } from "./admin-requests.vue?vue&type=template&id=4b7ac930&scoped=true&"
import script from "./admin-requests.vue?vue&type=script&lang=js&"
export * from "./admin-requests.vue?vue&type=script&lang=js&"
import style0 from "./admin-requests.vue?vue&type=style&index=0&id=4b7ac930&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7ac930",
  null
  
)

export default component.exports